// import React, { useState } from "react";
// import "./Profile_Expert.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

// const Profile_Expert = () => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [activeTab, setActiveTab] = useState("personal");

//   const [profileImage, setProfileImage] = useState(
//     "/assets/images/profile-icon.png",
//   );

//   const handleButtonClick = () => {
//     if (isEditing) {
//       console.log("Profile Saved!");
//     }
//     setIsEditing(!isEditing);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageUrl = URL.createObjectURL(file);
//       setProfileImage(imageUrl);
//       console.log("File selected:", file.name);
//     }
//   };

//   return (
//     <div className="profile-wrapper">
//       <div className="profile-container container">
//         <div className="profile-card">
//           <div className="profile-image-wrapper">
//             <input
//               type="file"
//               id="profile-image-upload"
//               hidden
//               accept="image/*"
//               onChange={handleFileChange}
//             />

//             <img src={profileImage} alt="profile" className="profile-image" />
//             <label
//               htmlFor="profile-image-upload"
//               className="edit-icon"
//               style={{ cursor: "pointer" }}
//             >
//               <FontAwesomeIcon icon={faPencilAlt} />
//             </label>
//           </div>

//           <div className="profile-form">
//             {activeTab === "personal" ? (
//               <>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Full Name</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Full Name"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>DOB</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Your DOB"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Profession</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Your Profession"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Mobile No</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Mobile No"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Whatsapp No</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Whatsapp Number"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>City</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Your City"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>State</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Your State"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Experience</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Your Experience"
//                       disabled={!isEditing}
//                     />
//                   </div>
//                 </div>
//               </>
//             ) : null}

//             <button
//               className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
//               onClick={handleButtonClick}
//             >
//               {isEditing ? "Save Profile" : "Edit Profile"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Profile_Expert;

import React, { useState, useEffect } from "react";
import "./Profile_Expert.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Account_Created_Modal from "../login/account-created-modal/Account_Created_Modal";
// Import the success modal


const Profile_Expert = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [showSuccess, setShowSuccess] = useState(false); // Success modal state

  const [profileImage, setProfileImage] = useState(
    "/assets/images/profile-icon.png",
  );

  // Auto-close logic: Closes the modal after 3 seconds
  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [showSuccess]);

  const handleButtonClick = () => {
    if (isEditing) {
      console.log("Profile Saved!");
      setShowSuccess(true); // Trigger success modal on save
    }
    setIsEditing(!isEditing);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
      console.log("File selected:", file.name);
    }
  };

  return (
    <div className="profile-wrapper">
      <div className="profile-container container">
        <div className="profile-card">
          <div className="profile-image-wrapper">
            <input
              type="file"
              id="profile-image-upload-expert"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />

            <img src={profileImage} alt="profile" className="profile-image" />
            <label
              htmlFor="profile-image-upload-expert"
              className="edit-icon"
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </label>
          </div>

          <div className="profile-form">
            {activeTab === "personal" ? (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      placeholder="Enter Full Name"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>DOB</label>
                    <input
                      type="text"
                      placeholder="Enter Your DOB"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Profession</label>
                    <input
                      type="text"
                      placeholder="Enter Your Profession"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>Mobile No</label>
                    <input
                      type="text"
                      placeholder="Enter Mobile No"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Whatsapp No</label>
                    <input
                      type="text"
                      placeholder="Enter Whatsapp Number"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      placeholder="Enter Your City"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>State</label>
                    <input
                      type="text"
                      placeholder="Enter Your State"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>Experience</label>
                    <input
                      type="text"
                      placeholder="Enter Your Experience"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
              </>
            ) : null}

            <button
              className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
              onClick={handleButtonClick}
            >
              {isEditing ? "Save Profile" : "Edit Profile"}
            </button>
          </div>
        </div>
      </div>


      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Profile Saved Successfully!"
      />
    </div>
  );
};

export default Profile_Expert;
